import services from 'services/services';

export const cancelTransaction = (payment_id: number) => services.post('/payments/cancel-transaction', { payment_id });
